export default __webpack_public_path__ + "static/media/gallery.3de9822f.png";